// One pending sample for a continuous interaction. Discrete events can flush
// the original move (including buttons/target) before committing, or discard it.
export function createPointerMoveScheduler({ requestFrame, cancelFrame, captureContext, isCurrent, handleMove }) {
  let pending = null;
  let frame = null;
  let generation = 0;

  function consume() {
    const sample = pending;
    pending = null;
    if (!sample || !isCurrent(sample.context)) return false;
    handleMove(sample.event);
    return true;
  }

  function cancelScheduledFrame() {
    generation += 1;
    if (frame !== null) cancelFrame(frame);
    frame = null;
  }

  return Object.freeze({
    queue(event) {
      pending = { event, context: captureContext() };
      if (frame !== null) return;
      const ticket = ++generation;
      frame = requestFrame(() => {
        if (ticket !== generation) return;
        frame = null;
        consume();
      });
    },
    flush() {
      cancelScheduledFrame();
      return consume();
    },
    cancel() {
      cancelScheduledFrame();
      pending = null;
    }
  });
}
